// Phase 2.3 Lite — Shared link utilities.
// Single source of truth for the four URL types Sitoa exposes. Keeps labels,
// descriptions, copy semantics, and absolute-URL resolution consistent across
// the Template Library, Event Setup, and any future surface.
//
// IMPORTANT: This file is admin-side only. Public pages must never import it.

import { toast } from 'sonner';

export const LINK_TYPES = {
  INTERNAL_TEMPLATE_PREVIEW: 'internal_template_preview',
  PUBLIC_DEMO:               'public_demo',
  CLIENT_REVIEW:             'client_review',
  EVENT_INVITATION:          'event_invitation',
};

export function getLinkLabel(type) {
  switch (type) {
    case LINK_TYPES.INTERNAL_TEMPLATE_PREVIEW: return 'Internal preview';
    case LINK_TYPES.PUBLIC_DEMO:               return 'Public demo';
    case LINK_TYPES.CLIENT_REVIEW:             return 'Client review';
    case LINK_TYPES.EVENT_INVITATION:          return 'Guest invitation';
    default:                                   return 'Link';
  }
}

export function getLinkDescription(type) {
  switch (type) {
    case LINK_TYPES.INTERNAL_TEMPLATE_PREVIEW:
      return 'For your team — internal review and mobile QA.';
    case LINK_TYPES.PUBLIC_DEMO:
      return 'Public marketing link for planners, couples, and outreach.';
    case LINK_TYPES.CLIENT_REVIEW:
      return 'Private token link for planner or couple approval.';
    case LINK_TYPES.EVENT_INVITATION:
      return 'Share this link with guests only when the invitation is ready.';
    default:
      return '';
  }
}

// Convert a path like "/demo/foo" or an already-absolute URL into a full
// absolute URL anchored at the current SPA origin.
export function toAbsoluteUrl(pathOrUrl) {
  if (!pathOrUrl) return '';
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return `${window.location.origin}${path}`;
}

// Copy + toast helper. `label` is the user-facing link name
// (e.g. "Public demo link", "Guest invitation link").
export async function copyLinkWithToast(pathOrUrl, label = 'Link') {
  if (!pathOrUrl) {
    toast.error('Could not copy link');
    return '';
  }
  const url = toAbsoluteUrl(pathOrUrl);
  try {
    await navigator.clipboard.writeText(url);
    toast.success(`${label} copied`);
    return url;
  } catch {
    toast.error('Could not copy link');
    return '';
  }
}
